import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import { makeStyles } from "@material-ui/core/styles";
import TabPanel from "./userTabs";
import { Typography } from "@material-ui/core";
import { actions } from "../../../redux/actions/alert";
import { connect } from "react-redux";
import {
  customDate,
  getBrandAndModel,
  getProviderName,
  getTimeGuarantee,
  getRemainingDaysGuarantee,
} from "../../../_utils/utils";
import { SellService } from "../../../services/sell.service";
import { GuaranteeService } from "../../../services/guarantee.service";

const styles = makeStyles((theme) => ({
  title: {
    flex: "1 1 100%",
    fontWeight: 900,
    color: theme.palette.primary.dark,
  },
}));

const Client = ({ value, index, addAlert, detailAlert }) => {
  const classes = styles();
  const titleColumns = [
    { title: "Nombre", field: "name" },
    { title: "Email", field: "email" },
    { title: "Teléfono", field: "telephone" },
    {
      title: "Producto",
      field: "product",
    },
    {
      title: "Sucursal de compra",
      field: "site",
    },
    {
      title: "Proveedor",
      field: "provider",
    },

    {
      title: "Días de garantía",
      field: "timeWarranty",
    },
    {
      title: "Días restantes",
      field: "remainingDays",
    },
    {
      title: "Aplicó garantia",
      field: "warranty",
    },
    {
      title: "Estatus garantía",
      field: "statusWarranty",
    },
    {
      title: "Fecha compra",
      field: "dateSell",
    },
  ];

  const [clientArray, setClientArray] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        let clientsObjArray = [];
        const { data } = await SellService.getAllSells();
        const result = await GuaranteeService.getAllGuarantees();
        const productsId = data.map((item) => item.product.id);
        const guarantees = productsId.map((id) => {
          return result.data.filter(
            (guaranteeItem) => guaranteeItem.product.id === id
          );
        });

        const sellsWithGuarantee = [];
        data.forEach((sell, i) => {
          if (guarantees[i].length) {
            sellsWithGuarantee.push({
              ...sell,
              guaranteeInfo: guarantees[i][0],
            });
          } else {
            sellsWithGuarantee.push(sell);
          }
        });
        console.log("sellsWithGuarantee", sellsWithGuarantee);
        sellsWithGuarantee.forEach((item, i) => {
          clientsObjArray[i] = {
            name: item.client?.name || "N/R",
            email: item.client?.email || "N/R",
            telephone: item.client?.telephone || "N/R",
            product: getBrandAndModel(item, true),
            site: item.site.name || "Error",
            provider: getProviderName(item),
            warranty: item.guaranteeInfo ? "Si" : "No",
            timeWarranty: getTimeGuarantee(item),
            remainingDays: getRemainingDaysGuarantee(item),
            statusWarranty: item.guaranteeInfo
              ? item.guaranteeInfo?.status_guarantee?.name || "Error"
              : "N/A",
            dateSell: customDate(item.updatedAt),
          };
        });
        setClientArray(clientsObjArray);
      } catch (error) {
        addAlert({ showAlert: true });
        detailAlert({ severity: "error", message: error.msgs, time: 2000 });
      }
    })();
  }, []);

  return (
    <React.Fragment>
      <TabPanel value={value} index={index}>
        {clientArray.length > 0 ? (
          <MaterialTable
            title={
              <Typography
                className={classes.title}
                color="primary"
                variant="h5"
                id="tableTitle"
                component="span"
              >
                Lista de clientes
              </Typography>
            }
            columns={titleColumns}
            data={clientArray}
          />
        ) : (
          <h2>Aún no hay cliente registrados</h2>
        )}
      </TabPanel>
    </React.Fragment>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(null, dispatch)(Client);
